import { combineReducers, configureStore } from '@reduxjs/toolkit';

// 상대 경로로 수정 (파일 구조에 따라 조정)
import pageReducer, { pageSlice } from './pageReducer';

const rootReducer = combineReducers({
    page: pageReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    reducer: rootReducer,
});

export default store;
